import { useMutation } from '@tanstack/react-query';
import type { ResendLeadOtpRequest, ResendLeadOtpResponse } from '@pms/shared';
import { resendLeadOtp } from '../services/api/leads.api';

/**
 * Re-issue (rotate) the OTP for a live pending lead. Write-only, no cache to
 * invalidate. Drives the resend affordance + cooldown in the OTP panel.
 */
export function useResendLeadOtp() {
  return useMutation<ResendLeadOtpResponse, unknown, ResendLeadOtpRequest>({
    mutationFn: resendLeadOtp,
  });
}
